import { formatToDate } from 'brazilian-values'

export const getFormattedDate = (date) => {
  return date ? formatToDate(new Date(date)) : '-'
}
